import { useEffect, useMemo, useRef, useSyncExternalStore } from "react";
import type { HostContext } from "@repo/bridge";

/**
 * Calls `onOrgChange` when the host switches organizations. The first org value establishes the
 * starting scope — whatever loaded at mount already targets it — so it is not a switch.
 */
export function useOrgChange(hostContext: HostContext, onOrgChange: () => void): void {
  const channel = useMemo(() => hostContext.channel("org"), [hostContext]);
  const orgId = useSyncExternalStore(channel.subscribe, channel.get);
  const previousOrgRef = useRef(orgId);

  useEffect(() => {
    const previous = previousOrgRef.current;
    previousOrgRef.current = orgId;
    if (!previous || !orgId || previous === orgId) return;
    onOrgChange();
  }, [orgId, onOrgChange]);
}
